import { useQuery } from '@tanstack/react-query'

import { getUsersFromDataAccessRequests } from 'services/data-access-requests'
import {
  DataAccessRequestQueryOptions,
  withDataAccessRequestsEnabled
} from 'services/data-access-requests/hooks/withDataAccessRequestsEnabled'
import { DataAccessRequestQueryKeys } from 'services/data-access-requests/queryKeys'
import type { GetDataAccessRequestFilterUsersResponse } from 'services/data-access-requests/types'
import type { ApiErrorResponse } from 'services/types'

export const useGetUsersFromDataAccessRequests = (
  options?: DataAccessRequestQueryOptions<GetDataAccessRequestFilterUsersResponse, ApiErrorResponse>
) => {
  const { enabled: enabledOption, ...restOptions } = options ?? {}

  return useQuery<GetDataAccessRequestFilterUsersResponse, ApiErrorResponse>({
    queryKey: DataAccessRequestQueryKeys.FilterUsers(),
    queryFn: ({ signal }) => getUsersFromDataAccessRequests({ signal }),
    enabled: withDataAccessRequestsEnabled(enabledOption ?? true),
    ...restOptions
  })
}
